import React, { useEffect } from "react";
import { Container, Grid, makeStyles, Typography } from '@material-ui/core';
import Header from '../../components/header';
//import Footer from '../../components/footer';
import { COLORS } from '../../constants/colors';
import googleLogo from '../../assets/images/googleLogo.png';


const useStyles = makeStyles({
  root: {
    backgroundColor: COLORS.grayScale[3],
    height: 592,
    marginTop: -10,
    width:'auto',
  },
  container: {
    //maxWidth: '90rem',
    height: 'auto',
  },
  grid: {
    //height: 'calc(100vh - 303px)',
    height: 'auto',
  },
  message: {
    marginTop: '2.5rem',
    fontSize: '2.5rem',
    lineHeight: '2.9375rem',
    //width: '35.125rem',
  },
});

export function LoginFail() {
  const classes = useStyles();
  useEffect(() => {
    setTimeout(() => {
      window.close();
    }, 1500);
  }, []);

  //return (
  //<h2>Thanks for loggin in!</h2>
  return (
    <>
      <section className={classes.root}>
        <Header />
        <Container className={classes.container}>
          <Grid
            className={classes.grid}
            container
            justify="center"
            alignItems="center"
            direction="row"
          >
            <Grid item>
              <img src={googleLogo} alt="Google Login" className={classes.message}/>
            </Grid>
            <Grid item>
              <Typography className={classes.message} variant="h5" component="h1" >
                This account doesn't have access to the candidate viewer
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </section>
    </>
  );
}